import { types } from "mobx-state-tree"
import PaginationOptions from './PaginationOptions'

const CustomerTransactionsUIStore = types.compose(
    PaginationOptions,
    types.model({

    })
)

export default CustomerTransactionsUIStore.create({
    rowsPerPage: 10,
    page: 0
})


// WEBPACK FOOTER //
// ./src/stores/CustomerTransactionsUIStore.js